import { Preferences } from '@capacitor/preferences';

import { persistor } from 'store/index';
import { clearBuffer } from 'utils-ts/recordingBuffer';

const LOCAL_PREFIX = 'a1.';
const PREFERENCES_PREFIX = 'a1.mobile.';

/**
 * localStorage keys that survive an instance change.
 */
const LOCAL_KEEP = ['a1.mobile.captureTuning', 'a1.mobileShell', 'a1.loginAudience.'];

const sweepLocalStorage = (): void => {
  const doomed = Object.keys(window.localStorage).filter(
    (key) => key.startsWith(LOCAL_PREFIX) && !LOCAL_KEEP.some((keep) => key.startsWith(keep))
  );

  doomed.forEach((key) => window.localStorage.removeItem(key));
};

/**
 * Sweep preferences by prefix.
 */
const sweepPreferences = async (): Promise<void> => {
  const { keys } = await Preferences.keys();

  await Promise.all(keys.filter((key) => key.startsWith(PREFERENCES_PREFIX)).map((key) => Preferences.remove({ key })));
};

/**
 * Discard every trace of the currently connected instance.
 */
const clearInstanceState = async (): Promise<void> => {
  persistor.pause();
  await persistor.purge();

  sweepLocalStorage();
  window.sessionStorage.clear();

  await sweepPreferences();
  await clearBuffer().catch(() => undefined);
};

export default clearInstanceState;
